import { render, staticRenderFns } from "./TagRiskLevel.vue?vue&type=template&id=56282e6e&scoped=true"
import script from "./TagRiskLevel.vue?vue&type=script&lang=ts"
export * from "./TagRiskLevel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56282e6e",
  null
  
)

export default component.exports